import { InputAdornment, TextField } from '@mui/material';
import { getIn, useFormikContext } from 'formik';
import { NumericFormat } from 'react-number-format';
import { TAssetInvestmentDetailsSchema } from '@brickwise/asset-validation/dist/asset/investmentData';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

interface Props {
  disabled?: boolean;
}

export const RepaymentAmount: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext<TAssetInvestmentDetailsSchema>();
  const errorMessage = getIn(formik.errors, 'investmentDetails.repaymentAmount');

  return (
    <NumericFormat
      customInput={TextField}
      margin="normal"
      label={t('dashboard.assets.addedit.investment.securitytype.fields.repaymentAmount')}
      type="text"
      variant="outlined"
      fullWidth
      decimalScale={2}
      defaultValue={formik.values.investmentDetails?.repaymentAmount}
      onValueChange={(values) => {
        if (values.floatValue || values.floatValue === 0) formik.setFieldValue('investmentDetails.repaymentAmount', values.floatValue);
      }}
      fixedDecimalScale
      error={!!errorMessage}
      disabled={disabled}
      helperText={errorMessage}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ mr: 1 }}>
            €
          </InputAdornment>
        ),
      }}
    />
  );
};
